<template>
  <div id="pageTable">
    <v-container fluid>
      <v-layout row wrap>
        <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
          <h3 class="font-weight-bold">Trekking Agencies</h3>
          <div class="text-xs-right">
            <export-button
                class="ml-2"
                v-if="$oauth.checkIfHasPermission(['export trekking-agency'])"/>
            <refresh-button :click-function="refreshData"></refresh-button>
          </div>
        </v-flex>
        <v-flex xs12>
          <v-card>
            <v-layout class="py-1 mx-2" row wrap>
              <v-flex class="pb-0" xs6>
                <v-text-field
                    :elevation="0"
                    class="hidden-sm-and-down "
                    flat
                    hide-details
                    placeholder="Search by typing here..."
                    prepend-inner-icon="search"
                    solo
                    v-model="filters.query"
                    @keypress.enter="handleFilterChange"
                ></v-text-field>
              </v-flex>
              <v-flex sm6 class="pb-0">
                <v-select
                    :items="status"
                    item-value="id"
                    item-text="name"
                    flat
                    hide-details
                    label="Filter By Status"
                    @change="handleFilterChange"
                    prepend-inner-icon="filter_list"
                    solo
                    clearable
                    v-model="filters.status"
                />
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                  :footer-props="footerProps"
                  :headers="headers"
                  :items="trekking_agencies"
                  :loading="loading"
                  :options.sync="pagination"
                  :server-items-length="totalNumber"
                  item-key="id">

                <template v-slot:item.status="{ item }">
                  <table-status :status="item.status"></table-status>
                </template>
                <template v-slot:item.remarks="{ item }">
                  {{item.remarks}}
                </template>
                <template v-slot:item.approved_rejected_by="{ item }">
                  {{item.approved_rejected_by ? item.approved_rejected_by.full_name : 'N/A'}}
                </template>
                <template v-slot:item.trekkers_count="{ item }">
                 <a @click="goToTrekkerList(item)">{{item.trekkers_count}}</a>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          @click="view(item)"
                          class="mr-2"
                          color="primary"
                          dark
                          dense
                          fab
                          v-on="on"
                          x-small>
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>
                    </template>
                    <span>View</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          @click="edit(item)"
                          color="primary"
                          dark
                          dense
                          fab
                          v-if="$oauth.checkIfHasPermission(['alter trekking-agency'])"
                          v-on="on"
                          x-small
                      >
                        <v-icon small>edit</v-icon>
                      </v-btn>
                    </template>
                    <span>Edit</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          @click="confirmDelete(item)"
                          class="ml-2"
                          color="red lighten-1"
                          dark
                          dense
                          fab
                          v-if="$oauth.checkIfHasPermission(['alter trekking-agency'])"
                          v-on="on"
                          x-small
                      >
                        <v-icon small>delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Delete</span>
                  </v-tooltip>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import {commonListMixin} from "../../mixins/commonListMixin";
import {validationMixin} from "../../mixins/validationMixin";
import TableStatus from '../../components/TableStatus'
import RefreshButton from "@/components/RefreshButton";

export default {
  components: {RefreshButton, TableStatus},
  data() {
    return {
      model: "trekking-agencies",
      title: "Trekking Agency",
      headers: [
        {
          text: 'S.N.',
          value: 's_no',
          sortable: false
        },
        {
          text: "Name",
          value: "name",
          sortable: false
        },
        {
          text: "Status",
          value: "status",
          sortable: false
        },
        {
          text:'Trekkers Count',
          value: 'trekkers_count',
          sortable: false
        },
        {
          text: "Remarks",
          value: "remarks",
          sortable: false,
        },

        {
          text: "Approved / Rejected By",
          value: "approved_rejected_by",
          sortable: false,
        },


        {
          text: "Created Date",
          value: "created_at"
        },
        {
          text: "Action",
          value: "action",
          sortable: false
        }
      ],
      status: [
        {
          id: -1,
          name: 'All'
        },
        {
          id: 1,
          name: 'Approved'
        },
        {
          id: 2,
          name: 'Applied/Pending'
        },
        {
          id: 3,
          name: 'Rejected'
        },
        {
          id: 4,
          name: 'Inactive'
        }
      ],
    };
  },
  mixins: [commonListMixin, validationMixin],
  computed: {

    trekking_agencies() {
      return this.$store.state.TrekkingAgencyList.all;
    },
  },
  methods: {
    view(item) {
      this.$router.push({
        name: "ViewTrekkingAgency",
        params: {
          id: item.id
        }
      });
    },
    edit(item) {
      this.$router.push({
        name: "TrekkingAgenciesEdit",
        params: {
          id: item.id
        }
      });
    },
    async confirmDelete(item) {
      this.destroy(item, this.title + " Deleted Successfully");
    },
    refreshData(){
      this.getAll();
    },
    goToTrekkerList(item){
      this.$router.push({name: 'TrekkersList', params: {id:  item.id}});
    }
  },
  mounted() {
    this.stateName = 'TrekkingAgencyList';
    this.$store.commit("TrekkingAgencyList/setModel", this.model);
    this.$store.commit("CommonList/setModel", this.model);
    this.$store.commit("TrekkingAgencyList/setFilters", {
      status: -1
    });
    this.pagination = this.serverPagination
  }
};
</script>
